import type { ReactNode } from 'react'
import styles from './OCRScopeJobDetailBodyBasicInformation.module.css'
import { OCRScopeJobDetailBodyTitle } from '@/features/jobs/scoping/components/OCRScopeJobDetailBodyTitle'
import { IconButton } from '@/components/IconButton'
import { dateFormatters } from '@/utils/date-util'

export interface OCRScopeJobDetailBodyBasicInformationProps {
  document?: ReactNode
  children?: ReactNode
}

export function OCRScopeJobDetailBodyBasicInformation({
  document,
  children,
}: OCRScopeJobDetailBodyBasicInformationProps) {
  return (
    <div className={styles.root}>
      <OCRScopeJobDetailBodyTitle title={'Basic Information'} />
      {document}
      <div className={styles.line}></div>

      <div className={styles.content}>{children}</div>
    </div>
  )
}

export interface OCRScopeJobDetailBodyBasicInformationDocumentProps {
  title: string
  dateCreated: Date
  onDownload: () => unknown
}

export function OCRScopeJobDetailBodyBasicInformationDocument({
  title,
  dateCreated,
  onDownload,
}: OCRScopeJobDetailBodyBasicInformationDocumentProps) {
  return (
    <div className={styles.documentContainer}>
      <div className={styles.documentTitleContainer}>
        <div className={styles.documentTitle}>{title}</div>
        <div className={styles.documentSubtitle}>
          {dateFormatters.dateTimeDefault.format(dateCreated)}
        </div>
      </div>
      <IconButton
        name="download"
        label="Download document"
        onPress={onDownload}
        size={24}
      />
    </div>
  )
}
